﻿/**
 * portal-link-group.repository
 * @namespace portal
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.portal').service('portal-link-group.repository', portalLinkGroupRepo);

	/** injection */
	portalLinkGroupRepo.$inject = ['$q', 'repositoryFactory', 'PortalRestangular'];

	/** implementation */
	function portalLinkGroupRepo($q, repositoryFactory, portalRestangular) {
		/** private properties */
		var portalGroups = [];

		/** create the repo */
		var repo = new repositoryFactory('PortalLinkGroup', portalRestangular);

		/** additional public methods */
		repo.getForUser = getForUser;
		repo.reorder = reorder;
		repo.resetGroups = resetGroups;

		/** get the groups for the user */
		function getForUser() {
			/** create the promise */
			var deferred = $q.defer();

			/** check for portal groups */
			if (portalGroups.length > 0) {
				/** set the current context */
				deferred.resolve(portalGroups);
			} else {
				/** load portal links */
				repo.getAll({ 'filter': { 'IsEnabled': true } }).then(function(groups) {
					/** set portal groups */
					portalGroups = groups;

					/** set the current context */
					deferred.resolve(portalGroups);
				});
			}

			/** return the promise */
			return deferred.promise;
		}

		/** reorder the groups */
		function reorder(groups) {
			return this.put(groups, '/reorder');
		}

		/** clear the groups */
		function resetGroups() {
			portalGroups = [];
		}

		/** return the repo */
		return repo;
	}
})();